import { jsx } from "react/jsx-runtime";
import { Box } from "./Box.js";
import { Item } from "./Item.js";
function Header({
  rightElements,
  subtext,
  thumbnail,
  title,
  ...props
}) {
  return /* @__PURE__ */ jsx(Box, {
    paddingBlock: "3",
    paddingInline: "6",
    ...props,
    children: (rightElements || subtext || thumbnail || title) && /* @__PURE__ */ jsx(Item, {
      thumbnail,
      rightElements,
      subtext,
      children: title
    })
  });
}
export {
  Header
};
//# sourceMappingURL=Header2.js.map
